import { render, staticRenderFns } from "./BanStore.vue?vue&type=template&id=3fa4557f"
import script from "./BanStore.vue?vue&type=script&lang=js"
export * from "./BanStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports